import styled from '@emotion/styled'
import { InputBase, Stack, Typography } from '@mui/material'
import { useTranslate } from 'GlobalStores/Cores/Translator/useTranslate'
import { observer } from 'mobx-react-lite'
import { useState } from 'react'
import { CardHelper } from './CardHelper'

const CreditCardNumber = observer(({ setCardNumber, loading }) => {
    const translate = useTranslate()

    const [cardNumberFormated, setCardNumberFormated] = useState('')

    const handleChange = e => {
        const value = e.target.value
        if (value.length > 19) return
        if (value.length === 0) {
            setCardNumberFormated('')
            setCardNumber('')
            return
        }
        if (/^\d*$/.test(value.replace(/\s/g, ''))) {
            const formatedValue = value.replace(/\s/g, '').replace(/(\d{4})(?=\d)/g, '$1 ')
            setCardNumberFormated(formatedValue)
            setCardNumber(value.replace(/\s/g, ''))
        }
    }

    return (
        <CreditCardNumberStyled sx={{ height: '80px', position: 'relative' }}>
            <label htmlFor="credit-card-number" style={{ paddingLeft: '16px', paddingBottom: '8px' }}>
                <Typography variant="body5" fontSize={'14px'} fontWeight={'400'} fontFamily={'Inter, NotoSansThai'} color="var(--input-label)">
                    {translate('card_number')}
                </Typography>
            </label>
            <InputBase
                id="credit-card-number"
                type="text"
                placeholder=" "
                value={cardNumberFormated}
                onChange={handleChange}
                disabled={loading}
                endAdornment={
                    <Stack sx={{ position: 'absolute', right: '16px', top: '50%', transform: 'translateY(-50%)' }}>
                        {CardHelper.BrandOfCard(cardNumberFormated)}
                    </Stack>
                }
                sx={{
                    '& .MuiInputBase-input': {
                        '&:disabled': {
                            backgroundColor: 'rgba(239, 239, 239, 0.3)'
                        }
                    }
                }}
            />
        </CreditCardNumberStyled>
    )
})

const CreditCardNumberStyled = styled(Stack)({
    height: '80px',
    label: {
        paddingLeft: '16px',
        paddingBottom: '8px'
    },
    '& .MuiInputBase-input': {
        border: '1px solid var(--input-border)',
        borderRadius: '8px',
        padding: '0 16px',
        height: '48px',
        outline: 'none',
        fontSize: '16px',
        fontWeight: '400',
        fontFamily: 'Inter, NotoSansThai',
        color: 'var(--input-text)',
        boxSizing: 'border-box',
        backgroundColor: 'var(--input-bg)',
        '&:not(:placeholder-shown)': {
            backgroundColor: 'var(--input-filled-bg)'
        }
    }
})

export default CreditCardNumber
